import { render, staticRenderFns } from "./CampaignHistoryCall.vue?vue&type=template&id=6b5e6528&scoped=true&"
import script from "./CampaignHistoryCall.vue?vue&type=script&lang=js&"
export * from "./CampaignHistoryCall.vue?vue&type=script&lang=js&"
import style0 from "./CampaignHistoryCall.vue?vue&type=style&index=0&id=6b5e6528&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5e6528",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTabsItems } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VTab,
  VTabItem,
  VTabs,
  VTabsItems,
})
